import { render, staticRenderFns } from "./password_reset.vue?vue&type=template&id=03777ee8&"
import script from "./password_reset.vue?vue&type=script&lang=js&"
export * from "./password_reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../projects/tuushin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports